module.exports = __webpack_public_path__ + "static/media/group-3@3x.f330e388.png";